import React, { useEffect, useState } from 'react';

export type LineItem = {
  qty: number | '';
  lengthFt: number | '';
  lengthIn: number | '';
};

export type BoxSelectorData = {
  boxType: string;
  ribType: string;
  lines: LineItem[];
};

type Props = {
  initialValue?: BoxSelectorData;
  onChange: (data: BoxSelectorData) => void;
  productionLineRiserPan?: boolean;
};

export default function ProductSpecificationLines({ initialValue, onChange, productionLineRiserPan }: Props) {
  const [boxType, setBoxType] = useState(initialValue?.boxType || (productionLineRiserPan ? 'BOX/SQ' : ''));
  const [ribType, setRibType] = useState(initialValue?.ribType || (productionLineRiserPan ? '5-RIB': ''));
  const [lines, setLines] = useState<LineItem[]>(
    initialValue?.lines || [{ qty: "", lengthFt: "", lengthIn: "" }]
  );

  useEffect(() => {
    onChange({ boxType, ribType, lines });
  }, [boxType, ribType, lines]);

  const handleLineChange = (index: number, field: keyof LineItem, value: string) => {
    const updated = [...lines];
    updated[index][field] = value === '' ? '' : Number(value);
    setLines(updated);
  };

  const handleAddLine = () => {
    setLines([...lines, { qty: '', lengthFt: '', lengthIn: '' }]);
  };

  const handleRemoveLine = (index: number) => {
    setLines(lines.filter((_, i) => i !== index));
  };

  return (
    <div className="production-line-container">
      {productionLineRiserPan && (
        <>
          <div className="product-box">
            <label style={{ fontWeight: 600, minWidth: "40px" }}>Box:</label>
            <div className="inp-bx">
              <div className='inp-bx-item'>
                <input
                  type="radio"
                  value="BOX/SQ"
                  checked={boxType === 'BOX/SQ'}
                  onChange={(e) => setBoxType(e.target.value)} />
                <label style={{ fontWeight: '600'}} >
                  BOX/SQ
                </label>
              </div>

              <div className='inp-bx-item'>
                <input
                  type="radio"
                  value="SQ/SQ"
                  checked={boxType === 'SQ/SQ'}
                  onChange={(e) => setBoxType(e.target.value)} />
                <label style={{ fontWeight: '600' }} >
                  SQ/SQ
                </label>
              </div>

              <div className='inp-bx-item'>
                <input
                  type="radio"
                  value="BOX/TT"
                  checked={boxType === 'BOX/TT'}
                  onChange={(e) => setBoxType(e.target.value)} />
                <label style={{ fontWeight: '600' }} >
                  BOX/TT
                </label>
              </div>
            </div>
          </div>

          <div className="product-rib">
            <label style={{ fontWeight: 600, minWidth: "40px"  }}>RIB:</label>
            <div className="inp-bx">
              <div className='inp-bx-item'>
                <input
                  type="radio"
                  value="2-RIB"
                  checked={ribType === '2-RIB'}
                  onChange={(e) => setRibType(e.target.value)} />
                <label style={{ fontWeight: '600' }} >
                  2-RIB
                </label>
              </div>

              <div className='inp-bx-item'>
                <input
                  type="radio"
                  value="5-RIB"
                  checked={ribType === '5-RIB'}
                  onChange={(e) => setRibType(e.target.value)} />
                <label style={{ fontWeight: '600' }} >
                  5-RIB
                </label>
              </div>
            </div>
          </div>
        </>
      )}

      <div>
        {lines.map((line, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "12px",
            }}>
            <div className='production-line-input-container'>
              <label>Qty</label>
              <input
                className='production-line-input'
                type="number"
                value={line.qty}
                onChange={(e) => handleLineChange(index, "qty", e.target.value)} />
            </div>

            <div className='production-line-input-container'>
              <label>*Length</label>
              <input
                className='production-line-input'
                type="number"
                value={line.lengthFt}
                onChange={(e) => handleLineChange(index, "lengthFt", e.target.value)} />
            </div>

            <div className='production-line-input-container'>
              <label>Ft</label>
              <input
                className='production-line-input'
                type="number"
                value={line.lengthIn}
                onChange={(e) => handleLineChange(index, "lengthIn", e.target.value)}
              />
            </div>

            <div className='production-line-input-container'>
              <label>In</label>
              {index > 0 && (
                <button
                  onClick={() => handleRemoveLine(index)}
                  className='trash-button'
                  aria-label="Remove line">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="18"
                    height="18">
                    <path fill='#444' d="M 15 4 C 14.476563 4 13.941406 4.183594 13.5625 4.5625 C 13.183594 4.941406 13 5.476563 13 6 L 13 7 L 7 7 L 7 9 L 8 9 L 8 25 C 8 26.644531 9.355469 28 11 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 9 L 27 9 L 27 7 L 21 7 L 21 6 C 21 5.476563 20.816406 4.941406 20.4375 4.5625 C 20.058594 4.183594 19.523438 4 19 4 Z M 15 6 L 19 6 L 19 7 L 15 7 Z M 10 9 L 24 9 L 24 25 C 24 25.554688 23.554688 26 23 26 L 11 26 C 10.445313 26 10 25.554688 10 25 Z M 12 12 L 12 23 L 14 23 L 14 12 Z M 16 12 L 16 23 L 18 23 L 18 12 Z M 20 12 L 20 23 L 22 23 L 22 12 Z" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>


      <button className='blueButtonOutline' onClick={handleAddLine}>+ ADD LINE</button>
    </div>
  );
}
